import { Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Alert, Form } from "../../../../layout";
import { Button, InputPass } from "../../../../controls";
import { Model, UseForm } from "../../../../hooks";
import { PassValidation } from "../../../../utils";
import { connect } from "react-redux";
import * as actions from "../../../../api/actions/actions";
import { useNavigate } from "react-router-dom";
import { controller, endpoints } from "../../../../api/actions/api";
import { ToFormData } from "../../../../hooks/Method";
import { PublishedWithChangesRounded } from "@mui/icons-material";

const ChangePass = (props) => {
  const { setActiveStep, setForgotVal, forgotVal, _getByObj } = props;
  const { ForgotMdl } = Model();
  const navigate = useNavigate();
  const [err, setErr] = useState();
  const [loading, setLoading] = useState(false);
  const { values, setValues, errors, setErrors, handleInpPass, passValid } =
    UseForm(ForgotMdl);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const validateForm = () => {
    let temp = {};
    temp.password = values.password !== "" ? "" : "Password is required.";
    temp.confirmPass =
      values.confirmPass !== ""
        ? values.confirmPass === values.password
          ? ""
          : "Password and Confirm password not match"
        : "Confirm Password is required.";
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      values.forgotStep = 3;
      const onComplete = (res) => {
        setLoading(false);
        res.status === 200 ? navigate("/owner_portal/home") : setErr(res.msg);
      };
      _getByObj(
        endpoints.AuthAdmin + controller.Forgot,
        ToFormData(values),
        actions.ActionType.Auth,
        onComplete
      );
    }
  };

  useEffect(() => {
    setValues(forgotVal);
    return () => {
      setValues();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setForgotVal({ ...values });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <Form noValidate onSubmit={submitForm}>
        <Grid container className="p-15 pt-0" spacing={3}>
          <Grid item xs={12} className="tx-center mt-20 pb-30">
            <h2 className="fs-24 fw-5 tx-upp h gray-color">Change Password</h2>
            <div className="pos-relative d-flex j-center mt-5">
              <div className="border-bottom w-60" />
            </div>
          </Grid>
          {err && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" color="error">
                <span className="fw-6 tx-upp"> Error:&nbsp;</span> {err}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <InputPass
              label="Password"
              name="password"
              value={values.password}
              onChange={handleInpPass}
              error={errors.password}
              className="input-primary w-100pr"
            />
            <PassValidation {...{ password: values.password, passValid }} />
          </Grid>
          <Grid item xs={12}>
            <InputPass
              label="Confirm Password"
              name="confirmPass"
              value={values.confirmPass}
              onChange={(e) => handleInpPass(e, true)}
              error={errors.confirmPass}
              className="input-primary w-100pr"
            />
          </Grid>
          <Grid item xs={12} className="text-center">
            <Button
              type="submit"
              loading={loading}
              size="large"
              className="w-100pr br-20"
              startIcon={<PublishedWithChangesRounded />}
            >
              Change Password
            </Button>
          </Grid>
        </Grid>
      </Form>
      <Alert
        onClick={() => setActiveStep(undefined)}
        alert={alert}
        setAlert={setAlert}
      />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapActionToProps = {
  _getByObj: actions.getByObj,
};

export default connect(mapStateToProps, mapActionToProps)(ChangePass);
